import PagedMixin from '@/common/pagination/mixins/paged-mixin'
import User from '@/users/entities/user'
import { Component, Mixins, Prop, Vue, Watch } from 'vue-property-decorator'

@Component
export default class UsersTable extends Mixins(PagedMixin) {

  @Prop({ type: Boolean, default: false })
  public loading!: boolean

  @Prop({ default: () => [] })
  public users!: User[]

  get headers() {
    return [
      { text: 'Name', value: 'name', sortable: false },
      { text: 'E-Mail', value: 'email' },
      { text: 'Adresse', value: 'address', sortable: false },
      { text: 'Funktion', value: 'role' },
      { text: 'Aktionen', value: 'action', sortable: false },
    ]
  }

  private edit(user: User) {
    this.$emit('edit', user)
  }

  private impersonate(user: User) {
    this.$emit('impersonate', user)
  }

  private deleteUser(user: User) {
    if (confirm('Soll der Benutzer wirklich gelöscht werden?')) {
      this.$emit('delete', user)
    }
  }
}
